<template>
    <main class="app-content">
        <div class="app-title">
            <div>
                <h1>
                    <font-awesome-icon icon="credit-card"/>
                    {{$t('title')}}
                </h1>
            </div>
        </div>
        <credit-deposit-list />
    </main>
</template>

<script>
    import CreditDepositList from "./CreditDepositList";

    export default {
        components: {CreditDepositList},
        data: function () {
            return {}                                                                          
        },
        i18n: {
            messages: {
                en: {
                    title: 'Credit deposit list',
                },
                vi: {
                    title: 'Danh sách lệnh nạp tiền',
                }
            }
        },
    };
</script>